import { render, staticRenderFns } from "./billboardBannerMiddle.vue?vue&type=template&id=faf7b850&scoped=true&"
import script from "./billboardBannerMiddle.vue?vue&type=script&lang=js&"
export * from "./billboardBannerMiddle.vue?vue&type=script&lang=js&"
import style0 from "./billboardBannerMiddle.vue?vue&type=style&index=0&id=faf7b850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf7b850",
  null
  
)

export default component.exports